// extracted by mini-css-extract-plugin
export default {"mapContainer":"yandexMap-module__mapContainer__rOdFl"};